const datasetName = (stage = 'dev') => `blog-${stage}`

const datasetStage = process.env.SANITY_STUDIO_API_DATASET_STAGE || 'dev'
const dataset = datasetName(datasetStage)
const dotComDataset = datasetStage
export const projectId = 'rd0y3pad'

export {dataset, datasetStage, dotComDataset, datasetName}
